module.exports = __webpack_public_path__ + "static/image/history/pc/201605@3x.ver2_0_2.jpg?942b9174";